/** Formats a decimal rate to a percentage string. e.g. 0.0215 => '2,15%' */
export const formatPercentage = (decimalRate: number) => {
  return `${(decimalRate * 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`
}
